export interface ApiEntry {
  id: string;
  base: string;
}

const isFinnairHost = (host: string): boolean => host === 'finnair.com' || host.endsWith('.finnair.com');

export const collectFinnairApiUrls = (config: unknown): ApiEntry[] => {
  const found = new Map<string, ApiEntry>();

  const walk = (value: unknown): void => {
    if (typeof value === 'string' && value.startsWith('https://')) {
      try {
        const { origin, host, pathname } = new URL(value);
        if (isFinnairHost(host)) {
          const base = `${origin}${pathname}`.replace(/\/+$/, '');
          found.set(base, { id: base.replace(/^https:\/\//, ''), base });
        }
      } catch {
        // not a parseable URL — ignore
      }
    } else if (value && typeof value === 'object') {
      Object.values(value).forEach(walk);
    }
  };

  walk(config);
  return [...found.values()].sort((left, right) => left.id.localeCompare(right.id));
};

/**
 * API ids allowed to receive W3C trace headers. Empty until an owner confirms CORS for
 * `traceparent`/`tracestate` and `pnpm datadog:check-tracing` passes for that id — so by default
 * nothing is traced and RUM injects no headers on any cross-origin request.
 */
export const VERIFIED_API_ID_PARTS = [
  '/d/fcom/order',
  '/d/fcom/offers',
  '/d/fcom/ancillary',
  '/d/fcom/cart',
  '/d/fcom/instantsearch',
  '/d/consent-registry/consent',
  '/d/finnair-personalization/recommendation',
];

export const isTracingAllowed = (url: string, knownApis: ApiEntry[]): boolean => {
  return knownApis.some((api) => url.startsWith(api.base) && VERIFIED_API_ID_PARTS.some((id) => api.id.includes(id)));
};
